import styled from "styled-components";
import * as Variable from "../../CSSVariables";

export const BagSummaryStyle = styled.div`
  background-color: ${Variable.white};
  max-width: 600px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
  box-shadow: 0 10px 8px 0px rgb(191 191 191 / 12%);
  padding-top: 30px;
  padding-bottom: 30px;
  height: 203px;

  @media only screen and (min-width: ${Variable.mobile}) {
    box-shadow: none;
    padding-bottom: 0;
    height: auto;
  }
  @media only screen and (min-width: ${Variable.tablet}) {
    padding-top: 0;
  }
  > div {
    /* padding: 24px 0; */
  }
  .summary-amounts {
    .detail {
      font-size: 2.6rem;
      font-weight: ${Variable.semiBold};
      > div {
        flex: auto;
        /* padding: 6px 0; */
      }
      .title {
      }
      .value {
        text-align: right;
      }
    }
  }
  .summary-proceed {
    p {
    }
    a {
      &.link-as-btn {
        max-width: 135px;
        display: inline-block;
        margin: 0 8px;

        @media only screen and (min-width: ${Variable.customRetina}) {
          max-width: 160px;
        }
        @media only screen and (min-width: ${Variable.mobile}) {
          max-width: 182px;
        }

        &.ghost {
          border: 1px solid ${Variable.valhalla};
          background-color: ${Variable.white};
          color: ${Variable.valhalla};
          font-weight: ${Variable.semiBold};

          &:hover {
            background-color: #f9f9f9;
          }
        }
      }
    }
    border: 0;
  }
  button {
    width: auto;
    padding: 14px 36px;
  }
  &.bag-summary-fixed {
    position: fixed;
    top: 0;
    z-index: 1;

    @media only screen and (min-width: ${Variable.mobile}) {
      position: static;
    }
  }
  .link-as-btn {
    max-width: 140px;
    height: 46px;
    line-height: 15px;

    &.invalid {
      pointer-events: none;
    }
  }
`;
